/**
 * Created by wafer on 2017/5/23.
 */
import request from '../utils/request';
import { Base64 } from 'js-base64';
import { downloadFile } from '../utils/download';

export const getMeetingInfo = ({ meetingId, locale }) => {
  const url = `/smartmeeting/smart/third/findMeetingDetail?lang=${locale}&meetingId=${meetingId}`;
  return request(url);
};

export const getMeetingUsers = ({ members, fuIds, holderId, locale }) => {
  return request(
    `/iwork/userInfo/findUsersById?lang=${locale}&members=${members}&fulIds=${fuIds}&holderId=${holderId}`
  );
};

export const getMeetingAgenda = ({ meetingId, locale }) => {
  return request(
    `/smartmeeting/smart/agenda/getAgendaList?lang=${locale}&meetingId=${meetingId}`
  );
};

export const saveAgenda = ({ meetingId, data, locale, type = 0 }) => {
  return request(
    `/smartmeeting/smart/agenda/saveAgenda?lang=${locale}&meetingId=${meetingId}&data=${Base64.encode(
      data
    )}&type=${type}`,
    { method: 'POST' }
  );
};

export const getSignInfo = ({ meetingId, locale }) => {
  return request(
    `/smartmeeting/smart/third/getMeetingSignInfo?lang=${locale}&meetingId=${meetingId}`
  );
};

export const reSign = ({ locale, id }) => {
  return request(`/smartmeeting/smart/third/reSign?lang=${locale}&id=${id}`, {
    method: 'POST'
  });
};

export const saveExternal = ({ external, locale }) => {
  let uri = '/iwork/external/saveUser?lang=' + locale;
  if (external.id) {
    uri = '/iwork/external/updateUser?lang=' + locale;
  }
  return request(uri, {
    method: 'POST',
    body: JSON.stringify({
      id: external.id || '',
      userName: external.userName,
      mobile: external.mobile,
      email: external.email,
      company: external.company || '',
      telAreaCode:external.telAreaCode || '+86'
    })
  });
};

export const deleteExternal = ({ external, locale }) => {
  let uri = '/iwork/external/updateUserState?lang=' + locale;
  return request(uri, {
    method: 'POST',
    body: JSON.stringify({
      id: external.id,
      state: 1
    })
  });
};

export const getSvc = ({}) => {
  let uri = '/smartmeeting/smart/meetingsvc/levels';
  return request(uri);
};

export const saveSvc = ({ locale, data, levelId, meetingId, type, skipPrice = 0 }) => {
  return request(
    `/smartmeeting/smart/meetingsvc/save?lang=${locale}&levelId=${levelId}&meetingId=${meetingId}&data=${Base64.encode(
      JSON.stringify(data)
    )}&type=${type}&skipPrice=${skipPrice}`,
    { method: 'POST' }
  );
};

export const getMeetingSvc = ({ meetingId, locale }) => {
  return request(
    `/smartmeeting/smart/meetingsvc/getMeetingSvc?lang=${locale}&meetingId=${meetingId}`
  );
};

export const getMeetingVideo = ({ meetingId, locale }) => {
  return request(
    `/smartmeeting/smart/meetingvideo/getMeetingVideo?lang=${locale}&meetingId=${meetingId}`
  );
};

export const saveVideoApplyFuc = ({ locale, meetingVideo }) => {
  const url = `smartmeeting/smart/meetingvideo/saveMeetingVideo?lang=${locale}`;
  const data = {
    id: meetingVideo.id,
    meetingId: meetingVideo.meetingId,
    applyType: meetingVideo.applyType,
    contactUser: meetingVideo.contactUser,
    contactMobile: meetingVideo.contactMobile,
    requirement: meetingVideo.requirement,
    filePath: meetingVideo.filePath,
    fileName: meetingVideo.fileName,
    remark: meetingVideo.remark,
    state: meetingVideo.state
  };
  return request(url, { method: 'POST', body: JSON.stringify(data) });
};

export const getDevice = ({ locale, type, includeDel }) => {
  return request(
    `/smartmeeting/smart/meetingDevice/getAllDevice?lang=${locale}&type=${type}&includeDel=${includeDel ||
      0}`
  );
};

export const saveMeetingDevice = ({ locale, meetingId, data, type }) => {
  return request(
    `/smartmeeting/smart/meetingDevice/saveMeetingDevice?lang=${locale}&meetingId=${meetingId}&data=${data}&type=${type}`
  );
};

export const getMeetingDevice = ({ locale, meetingId }) => {
  return request(
    `/smartmeeting/smart/meetingDevice/getMeetingDevice?lang=${locale}&meetingId=${meetingId}`
  );
};
export const sendMsgToUser = ({ payload, locale }) => {
  return request(
    `/smartmeeting/smart/third/sendMsgToUser?userId=${
      payload.userId
    }&meetingId=${payload.meetingId}&userType=${
      payload.userType
    }&lang=${locale}`
  );
};

export const getNoticeConfig = lang => {
  return request(`/smartmeeting/smart/third/getNoticeConfig?lang=${lang}`);
};

export const getInviteFlag = lang => {
  return request(
    `/smartmeeting/smart/third/getInvitationServiceFlag?lang=${lang}`
  );
};

export const downloadMeetingSign = ({locale,meetingId,token}) =>{
  let url = `/smartmeeting/smart/report/downloadMeetingSign?meetingId=${meetingId}&lang=${locale}&token=${token}`;
  downloadFile('',url);
};



// WEBPACK FOOTER //
// ./src/services/meetingInfo.js